import Vue from 'vue';
import '@js/legacy';
import '@js/plugins';
import pluralize from 'pluralize';
import pinia from '@js/plugins/pinia';
import { useStudentStore } from '@js/stores/student/student';
import '@components/Shared';
import Loading from '@components/Loading.vue';
import PropertiesSearch2024 from '@components/PropertiesSearch2024.vue';
import PropertiesSearch2025 from '@components/PropertiesSearch2025.vue';
import JoinHouseMateGroup from '@components/JoinHouseMateGroup.vue';
import MarketplaceFaqs from '@components/MarketplaceFaqs.vue';
import VueLazyload from 'vue-lazyload';
import Vapor from 'laravel-vapor';
import { cdnAsset } from '@js/vapor';
import { initContentsInsuranceTooltip } from '@js/contentsInsuranceTooltip';

import { matchMediaQuery, isFullscreenSupported } from '@js/utilities';
import { initUtilityConnectTooltip } from '@js/utility-connect-tooltip';

Vapor.cdnAsset = cdnAsset;
window.Vapor = Vapor;

window.pluralize = pluralize;
window.matchMediaQuery = matchMediaQuery;
window.isFullscreenSupported = isFullscreenSupported;
Vue.config.productionTip = false;
Vue.use(VueLazyload);
initContentsInsuranceTooltip();

Vue.mixin({
  methods: {
    asset: window.Vapor.asset,
    cdnAsset: window.Vapor.cdnAsset,
  },
});

(async () => {
  if (
    document.getElementById('property') ||
    document.getElementById('PropertyShortlistNotificationApp')
  ) {
    await import('@components/Property');
  }

  if (document.getElementById('BoosterApp')) {
    await import('@components/LettingAgent/Booster');
  }

  if (document.getElementById('AgentAddEditPropertyApp')) {
    await import('@components/LettingAgent/Property/AddEditForm');
  }

  if (document.getElementById('PropertyExcelImportApp')) {
    await import('@components/LettingAgent/ExcelImport');
  }

  if (document.getElementById('CreateTenancyApp')) {
    await import('@components/LettingAgent/Tenancies/Create');
  }

  if (document.getElementById('UtilityAccountsApp')) {
    await import('@components/LettingAgent/UtilityAccounts/Index');
  }

  if (document.getElementById('UtilitiesOrderCreateApp')) {
    await import('@components/LettingAgent/UtilitiesOrder/Create');
  }

  if (document.getElementById('UtilitiesOrderEditApp')) {
    await import('@components/LettingAgent/UtilitiesOrder/Edit');
  }

  if (document.getElementById('NoteToUserApp')) {
    await import('@components/LettingAgent/Shared/NoteToUser');
  }

  if (document.getElementById('feedback-form-app')) {
    await import('@components/FeedbackForm');
  }

  if (document.getElementById('feedback-form-compact-app')) {
    await import('@components/FeedbackFormCompact');
  }
})();

if (document.getElementById('updatesSidebar')) {
  new Vue({
    name: 'UpdatesSidebarInstance',
    components: { UpdatesSidebar: () => import('@components/UpdatesSidebar') },
    methods: {
      showLandlordUpdates: function () {
        let classList = this.$refs.landlordUpdatesCounter.classList;

        if (!classList.contains('read-all')) {
          classList.add('read-all');
        }

        this.$refs.updatesSidebar.toggleUpdatesSidebar();
      },
    },
    pinia,
  }).$mount('#updatesSidebar');
}

if (document.getElementById('PropertiesSearchApp2024')) {
  const mountEl = document.getElementById('PropertiesSearchApp2024');
  if (mountEl) {
    mountEl.setAttribute('data-vue-ready', 'false');
  }

  document.addEventListener(
    'click',
    (event) => {
      if (
        !(event.target instanceof Element) ||
        !event.target.closest('[data-pre-vue-enquiry-cta]')
      ) {
        return;
      }

      if (!mountEl || mountEl.getAttribute('data-vue-ready') !== 'true') {
        window.pendingShortlistEnquirySelection = true;
      } else {
        window.dispatchEvent(
          new Event('shortlist-enquiry-selection-requested')
        );
      }
    },
    true
  );

  new Vue({
    name: 'PropertiesSearchInstance2024',
    components: {
      PropertiesSearch2024,
    },
    pinia,
    mounted() {
      this.$el?.setAttribute?.('data-vue-ready', 'true');
      try {
        const child = this.$children?.[0];
        const isLoggedInStudent =
          child?.isLoggedInStudent ?? child?.$props?.isLoggedInStudent;

        if (!isLoggedInStudent) {
          return;
        }

        const studentStore = useStudentStore();
        void studentStore.getShortlist();
      } catch (error) {
        void error;
      }
    },
  }).$mount('#PropertiesSearchApp2024');
}

if (document.getElementById('PropertiesSearchApp2025')) {
  const mountEl = document.getElementById('PropertiesSearchApp2025');
  if (mountEl) {
    mountEl.setAttribute('data-vue-ready', 'false');
  }

  new Vue({
    name: 'PropertiesSearchInstancePrivate',
    components: {
      PropertiesSearch2025,
    },
    pinia,
    mounted() {
      this.$el?.setAttribute?.('data-vue-ready', 'true');
      try {
        const child = this.$children?.[0];
        const isLoggedInStudent =
          child?.isLoggedInStudent ?? child?.$props?.isLoggedInStudent;

        if (!isLoggedInStudent) {
          return;
        }

        const studentStore = useStudentStore();
        void studentStore.getShortlist();
      } catch (error) {
        void error;
      }
    },
  }).$mount('#PropertiesSearchApp2025');
}

if (document.getElementById('JoinHousemateGroupApp')) {
  new Vue({
    name: 'JoinHousemateGroupInstance',
    components: {
      JoinHouseMateGroup,
    },
  }).$mount('#JoinHousemateGroupApp');
}

if (document.getElementById('TestimonialsCarousel')) {
  new Vue({
    name: 'TestimonialsCarouselInstance',
    components: {
      TestimonialsCarousel: () => import('@components/TestimonialsCarousel'),
    },
  }).$mount('#TestimonialsCarousel');
}

if (document.getElementById('BrandAmbassadorCarousel')) {
  new Vue({
    name: 'BrandAmbassadorCarouselInstance',
    components: {
      BrandAmbassadorCarousel: () =>
        import('@components/BrandAmbassadorCarousel'),
    },
  }).$mount('#BrandAmbassadorCarousel');
}

if (document.getElementById('BrandAmbassadorTestimonialsCarousel')) {
  new Vue({
    name: 'BrandAmbassadorTestimonialsCarouselInstance',
    components: {
      BrandAmbassadorTestimonialsCarousel: () =>
        import('@components/BrandAmbassadorTestimonialsCarousel'),
    },
  }).$mount('#BrandAmbassadorTestimonialsCarousel');
}

if (document.getElementById('PartnerWithUsCarousel')) {
  new Vue({
    name: 'PartnerWithUsCarouselInstance',
    components: {
      PartnerWithUsCarousel: () => import('@components/PartnerWithUsCarousel'),
    },
  }).$mount('#PartnerWithUsCarousel');
}

if (document.getElementById('analyticsMap')) {
  new Vue({
    name: 'AnalyticsMapInstance',
    components: { AnalyticsMap: () => import('@components/AnalyticsMap') },
  }).$mount('#analyticsMap');
}

if (document.getElementById('analyticsMarket')) {
  new Vue({
    name: 'AnalyticsMarketInstance',
    components: {
      ChartData: () => import('@components/ChartData'),
      ChartMarket: () => import('@components/ChartMarket'),
      ChartPie: () => import('@components/ChartPie'),
    },
  }).$mount('#analyticsMarket');
}

if (document.getElementById('analyticsPerformance')) {
  new Vue({
    name: 'AnalyticsPerformanceInstance',
    components: {
      ChartData: () => import('@components/ChartData'),
      ChartFloat: () => import('@components/ChartFloat'),
      ChartLine: () => import('@components/ChartLine'),
      ChartSwitch: () => import('@components/ChartSwitch'),
    },
  }).$mount('#analyticsPerformance');
}

if (document.getElementById('UploadCompanyLogoApp')) {
  new Vue({
    name: 'UploadCompanyLogoInstance',
    components: {
      UploadCompanyLogo: () => import('@components/Profile/UploadCompanyLogo'),
    },
  }).$mount('#UploadCompanyLogoApp');
}

if (document.getElementById('PartnersApp')) {
  new Vue({
    name: 'PartnersInstance',
    components: { Partners: () => import('@components/Partners') },
    pinia,
  }).$mount('#PartnersApp');
}

if (document.getElementById('IFrameLoadingApp')) {
  new Vue({
    name: 'IFrameLoadingInstance',
    components: { Loading },
  }).$mount('#IFrameLoadingApp');
}

for (const guideMap of document.getElementsByClassName('guide-amenities')) {
  new Vue({
    name: 'GuideAmenitiesInstance',
    components: {
      GuideAmenities: () => import('@components/GuideAmenities'),
    },
  }).$mount(guideMap);
}

if (document.getElementById('PropertyImageSwiperApp')) {
  new Vue({
    name: 'PropertyImageSwiperInstance',
    components: {
      PropertyImageSwiper: () => import('@components/PropertyImageSwiper'),
    },
  }).$mount('#PropertyImageSwiperApp');
}

if (document.getElementById('PropertyMediaBrowserApp')) {
  new Vue({
    name: 'PropertyMediaBrowserInstance',
    components: {
      PropertyMediaBrowser: () => import('@components/PropertyMediaBrowser'),
    },
  }).$mount('#PropertyMediaBrowserApp');
}

if (document.getElementById('PropertyMediaBrowserNewApp')) {
  new Vue({
    name: 'PropertyMediaBrowserNewInstance',
    components: {
      PropertyMediaBrowserNew: () =>
        import('@components/PropertyMediaBrowserNew'),
    },
  }).$mount('#PropertyMediaBrowserNewApp');
}
if (document.getElementById('PropertyMediaBrowser2024App')) {
  new Vue({
    name: 'PropertyMediaBrowser2024Instance',
    components: {
      PropertyMediaBrowser2024: () =>
        import('@components/PropertyMediaBrowser2024'),
    },
  }).$mount('#PropertyMediaBrowser2024App');
}

if (document.getElementById('SimilarPropertiesApp')) {
  new Vue({
    name: 'SimilarPropertiesInstance',
    components: {
      SimilarProperties: () => import('@components/Property/SimilarProperties'),
    },
  }).$mount('#SimilarPropertiesApp');
}

if (document.getElementById('SimilarPropertiesCarouselApp')) {
  new Vue({
    name: 'SimilarPropertiesCarouselInstance',
    pinia,
    components: {
      SimilarPropertiesCarousel: () =>
        import('@components/Property/SimilarPropertiesCarousel'),
    },
  }).$mount('#SimilarPropertiesCarouselApp');
}

if (document.getElementById('mobileShareElementApp')) {
  new Vue({
    name: 'MobileShareElementInstance',
    components: {
      UhShare: () => import('@components/Shared/UhShare.vue'),
      ShortlistToggleSmall: () =>
        import('@components/Property/ShortlistToggleSmall'),
    },
  }).$mount('#mobileShareElementApp');
}

if (document.getElementById('PropertySidebarApp')) {
  new Vue({
    name: 'PropertySidebarInstance',
    components: {
      PropertySidebar: () => import('@components/Property/PropertySidebar'),
      ShortlistToggle: () => import('@components/Property/ShortlistToggle'),
    },
  }).$mount('#PropertySidebarApp');
}

if (document.getElementById('PropertySidebarNewApp')) {
  new Vue({
    name: 'PropertySidebarNewInstance',
    components: {
      PropertySidebarNew: () =>
        import('@components/Property/PropertySidebarNew'),
      ShortlistToggle: () => import('@components/Property/ShortlistToggle'),
    },
  }).$mount('#PropertySidebarNewApp');
}

if (document.getElementById('DownloadFileApp')) {
  new Vue({
    name: 'DownloadFileInstance',
    components: {
      DownloadFile: () =>
        import('@components/LettingAgent/ResourceCentre/DownloadFile.vue'),
    },
  }).$mount('#DownloadFileApp');
}

for (const nextPreviousProperty of document.querySelectorAll(
  '[data-uh="next-previous-property"]'
)) {
  new Vue({
    name: 'NextPreviousFiltersInstance',
    components: {
      NextPreviousInfo: () => import('@components/Property/NextPreviousInfo'),
      NextPreviousFilters: () =>
        import('@components/Property/NextPreviousFilters'),
    },
    data: {
      showFilters: false,
      slideInFilters: false,
    },
    methods: {
      transitionFilters() {
        this.showFilters = !this.showFilters;
      },
    },
  }).$mount('#' + nextPreviousProperty.getAttribute('id'));
}

for (const shareElement of document.querySelectorAll('[data-share-button]')) {
  new Vue({
    name: 'ShareIconInstance',
  }).$mount(shareElement);
}

for (const utilitiesListElement of document.querySelectorAll(
  '[data-utilities-list]'
)) {
  new Vue({
    name: 'UtilitiesListElement',
    components: {
      UtilitiesInlineList: () =>
        import(
          '@components/LettingAgent/UtilitiesOrder/Shared/UtilitiesList/UtilitiesInlineList'
        ),
    },
  }).$mount(utilitiesListElement);
}

document.body.addEventListener('change', (event) => {
  const target = event.target;
  if (
    target &&
    target.matches &&
    target.matches("input[type='checkbox'][id*='_modal']")
  ) {
    const isChecked = target.checked;
    const header = document.querySelector('header.header');
    if (isChecked) {
      const scrollbarWidth =
        window.innerWidth - document.documentElement.clientWidth;
      document.body.style.setProperty(
        '--scrollbar-width',
        `${scrollbarWidth}px`
      );
      document.body.style.paddingRight = `${scrollbarWidth}px`;
      document.body.style.overflowY = 'hidden';
      if (header) header.style.paddingRight = `${scrollbarWidth}px`;
    } else {
      document.body.style.removeProperty('--scrollbar-width');
      document.body.style.paddingRight = '';
      document.body.style.overflowY = '';
      if (header) header.style.paddingRight = '';
    }
  }
});

// Feedback Form Component
if (document.getElementById('feedback-form-app')) {
  new Vue({
    name: 'FeedbackFormInstance',
    components: {
      FeedbackForm: () => import('@components/FeedbackForm'),
    },
  }).$mount('#feedback-form-app');
}

// Feedback Form Compact Component
if (document.getElementById('feedback-form-compact-app')) {
  new Vue({
    name: 'FeedbackFormCompactInstance',
    components: {
      FeedbackFormCompact: () => import('@components/FeedbackFormCompact'),
    },
  }).$mount('#feedback-form-compact-app');
}

// Marketplace FAQs
if (document.getElementById('marketplace-faqs-app')) {
  new Vue({
    name: 'MarketplaceFaqs',
    components: {
      MarketplaceFaqs,
    },
  }).$mount('#marketplace-faqs-app');
}

initUtilityConnectTooltip();
